/**
 * @generated SignedSource<<d5feddcad266f81e1e55d7f9121a50ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreProductList_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StoreProductPackageItem_session">;
  readonly " $fragmentType": "StoreProductList_session";
};
export type StoreProductList_session$key = {
  readonly " $data"?: StoreProductList_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreProductList_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreProductList_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StoreProductPackageItem_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "47ce233a79fba9db70bb35c403dcb244";

export default node;
